import { render, staticRenderFns } from "./ReceiveTable.vue?vue&type=template&id=99b45f86&scoped=true&"
import script from "./ReceiveTable.vue?vue&type=script&lang=js&"
export * from "./ReceiveTable.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveTable.vue?vue&type=style&index=0&id=99b45f86&scoped=true&lang=css&"
import style1 from "./ReceiveTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b45f86",
  null
  
)

export default component.exports